<div (click)="highlightRoute($event)" class="item" [class.selected-direction]="selected()">
  <div class="icon-wrapper">
    <div class="direction-wrapper">
      <div class="directions-icon-wrapper">
        @if (direction().isToNextArea) {
          @if (direction().nextAreaId && direction().categoryIcon) {
            <!-- <cue-image [src]="direction.categoryIcon"></cue-image> -->
            <img [src]="direction().categoryIcon" />
          } @else {
            @if (direction().nextAreaId) {
              <cue-icon [icon]="ICONS.cueMap" />
            }
            @if (!direction().nextAreaId) {
              <cue-icon [icon]="getArrowIcon(0)" />
            }
          }
        } @else {
          <cue-icon [icon]="getArrowIcon(direction().angleDirection)" />
        }
      </div>

      <div class="right-side">
        <!--      VZDALENOST-->
        <div class="direction">{{ direction().distance | number: '0.0-0' : 'en' }}m</div>
        @if (routeNoteNumber(); as noteNumber) {
          <span class="route-note-number">{{ noteNumber }}</span>
        }
        @if (direction().isToNextArea && direction().nextAreaId) {
          @if (direction().isToNextArea && direction().nextAreaId) {
            <!--            <button (click)="goToNextArea($event)" class="normal primary">
                            @if (direction.categoryIcon) {
                                <img [src]="direction.categoryIcon" />
                                &lt;!&ndash;                        <cue-image [src]="direction.categoryIcon" ></cue-image>&ndash;&gt;
                            } @else {
                                <cue-icon [icon]="ICONS.cueMap"></cue-icon>
                            }
                        </button>-->
          }
        } @else {
          @if (direction().isToNextArea) {
            <div class="end-marker">
              <cue-icon [icon]="ICONS.cueMarker" />
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
